export const BILL_DETAILS_STYLES = {
  MAIN: {
    main: 'bg-bw07 flex fixed inset-0 bg-opacity-70 z-50 justify-end items-stretch',
    content: 'cursor-default block w-[646px] static h-full',
    exit: 'absolute top-3 left-4 cursor-pointer z-10',
  },
  ATTACHMENT: {
    wrapper: 'p-[24px] h-[75%]',
  },
};
